/* eslint-disable no-console */
import { useEffect, useMemo, useState } from "react";

import { SignIn, Signup, UnauthorizedDomain } from "views";
import { ROUTES } from "constants/routes";
import { useInstance, useTranslation } from "hooks";

import "remixicon/fonts/remixicon.css";
import { SITE_META } from "utils";
import { Success } from "./success";
import GlobalInstanceManager from "instance-manger";

interface IMain {
  instance_id?: string;
  lang?: string;
  env?: string;
}
const Main = ({ instance_id, lang = "en", env }: IMain) => {
  const [loadingTranslation, setLoadingTranslation] = useState(false);
  const {
    getInstanceDetails,
    instanceDetailsLoading,
    currentScreen,
    setCurrentScreen,
  } = useInstance();

  const { onStepChangeEvent, onErrorEvent } = GlobalInstanceManager;

  const { init } = useTranslation();

  const initInstance = async () => {
    if (instance_id) {
      const resp = await getInstanceDetails(
        instance_id,
        SITE_META[env as "prod"].apiUrl
      );

      if (resp.statusCode !== 200) {
        onErrorEvent({ error: resp, type: "instance-details" });
        setCurrentScreen(ROUTES.UNAUTHRIZED_DOMAIN);
        return;
      } else {
        onStepChangeEvent({ data: resp?.data || resp, type: "instance-details" });
      }
    }

    setLoadingTranslation(true);
    await init(lang);
    setLoadingTranslation(false);
  };

  useEffect(() => {
    initInstance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderComponent = useMemo(() => {
    switch (currentScreen) {
      case ROUTES.SIGNIN:
        return (
          <SignIn loading={instanceDetailsLoading || loadingTranslation} />
        );
      case ROUTES.SIGNUP:
        return <Signup />;
      case ROUTES.UNAUTHRIZED_DOMAIN:
        return <UnauthorizedDomain />;
      case ROUTES.LOADING:
        return <SignIn loading />;
      case ROUTES.SUCCESS:
        return <Success type="signin" />;
      default:
        return <div>Nothing To Show</div>;
    }
  }, [currentScreen, loadingTranslation, instanceDetailsLoading]);

  return renderComponent;
};

export default Main;
